export * from './NewsCard'
